var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{attrs:{"id":"admin-header-box"}},[_c('topHeader')],1),_c('el-container',{staticClass:"main-container"},[_c('el-aside',{attrs:{"id":"left-menu-list-box","width":"220px"}},[_c('leftMenu')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }